import Warning from "@/assets/icon/Warning";
import IDialogProps from "@/interfaces/Props/Dialog/IDialogProps";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Stack,
} from "@mui/material";
import { forwardRef } from "react";
import Label from "../Label/Label";
import Info from "@/assets/icon/Info";
import Failed from "@/assets/icon/Failed";

const AlertDialog = forwardRef<HTMLDivElement, DialogProps & IDialogProps>(
  ({ open, type, title, contentText, onCancel, onSave, ...others }, ref) => {
    return (
      <Dialog
        {...others}
        open={open}
        onClose={onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {(() => {
          switch (type) {
            case "normal":
              return (
                <DialogTitle id="alert-dialog-title">
                  <Label id={title} />
                </DialogTitle>
              );
            case "info":
              return (
                <DialogTitle id="alert-dialog-title">
                  <Stack spacing={4} direction="row" alignItems="center">
                    <Info color="info" />
                    <Label id={title} />
                  </Stack>
                </DialogTitle>
              );
            case "warning":
              return (
                <DialogTitle id="alert-dialog-title">
                  <Stack spacing={4} direction="row" alignItems="center">
                    <Warning color="warning" />
                    <Label id={title} />
                  </Stack>
                </DialogTitle>
              );
            case "error":
              return (
                <DialogTitle id="alert-dialog-title">
                  <Stack spacing={4} direction="row" alignItems="center">
                    <Failed color="error" />
                    <Label id={title} />
                  </Stack>
                </DialogTitle>
              );
            default:
              break;
          }
        })()}

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {contentText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {(() => {
            switch (type) {
              case "normal":
              case "info":
              case "error":
                return (
                  <Stack direction="row" spacing={2}>
                    <Button onClick={onCancel}>
                      <Label id={"btn_confirm"} />
                    </Button>
                  </Stack>
                );

              default:
                return (
                  <Stack direction="row" spacing={2}>
                    <Button onClick={onCancel}>
                      <Label id={"btn_cancel"} />
                    </Button>
                    <Button onClick={onSave} autoFocus>
                      <Label id={"btn_agree"} />
                    </Button>
                  </Stack>
                );
            }
          })()}
        </DialogActions>
      </Dialog>
    );
  }
);

export default AlertDialog;
